import PropTypes from 'prop-types';
import React from 'react';

import styles from './SmallCaps.module.scss';

const SmallCaps = ({
  as: Tag = 'span',
  size = 'xs',
  tone = 'label',
  className,
  children,
  ...rest
}) => (
  <Tag
    className={[styles.smallCaps, styles[size], styles[tone], className].filter(Boolean).join(' ')}
    {...rest}
  >
    {children}
  </Tag>
);

SmallCaps.propTypes = {
  as: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm']),
  tone: PropTypes.oneOf(['label', 'muted', 'band', 'strong', 'alert', 'inverse', 'done', 'warn']),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default SmallCaps;
